import React from "react";
import PropTypes from "prop-types";

import AttributionAreaBasicDesktop from "./AttributionAreaBasicDesktop";
import AttributionAreaBasicNonDesktop from "./AttributionAreaBasicNonDesktop";

const AttributionAreaBasic = ({ onDesktop }) =>
    onDesktop ? (
        <AttributionAreaBasicDesktop />
    ) : (
        <AttributionAreaBasicNonDesktop />
    );

AttributionAreaBasic.propTypes = {
    onDesktop: PropTypes.bool.isRequired
};

export default AttributionAreaBasic;
